import React, { useState } from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { OceanShipImg, AirShipImg } from '../../Constant/Index';
// SLick Slider Lirbaries Imported Here
import { Link } from 'react-router-dom';


const ShipperInsurance = () => {
    let theText = [
        '"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
        'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?',
        'Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"'
    ];
    let Shippings = [
        {
            ShippingName: "Ocean Shipment",
            Paragraphs: theText,
            Image: OceanShipImg
        },
        {
            ShippingName: "Air Shipment",
            Paragraphs: theText,
            Image: AirShipImg
        }
    ]
    return (
        <>
            <Header />
            {/* Terms Conditions Section Start Here */}
            <section className="insurance-insurance pt-3 pt-lg-5 pb-5 mt-3">
                <div className="container">
                    <div className="ship-insurance-start">
                        <div className="top-headings">
                            <h2 className="md-heading text-center">Shipper’s Insurance</h2>
                            <p className="lg-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit</p>
                        </div>
                        <div className="shipment-list">
                            <div className="row">
                                {
                                    Shippings.map((Shipping, index) => {
                                        if ((index + 1) % 2 !== 0) {
                                            return (
                                                <>
                                                    <div className="col-md-6 mt-5 px-md-4">
                                                        <figure className="shipping-image">
                                                            <img src={Shipping.Image} alt="" className="the-img w-100 img-fluid" />
                                                        </figure>
                                                    </div>
                                                    <div className="col-md-6 mt-3 mt-md-5 px-md-4">
                                                        <div className="shipping-text h-100 d-flex flex-column justify-content-center">
                                                            <h3 className="md-heading secondary-text"><span className="md-heading pe-2">{index+1}.</span>{Shipping.ShippingName}</h3>
                                                            <div className="the-text mt-2 mt-md-4">
                                                                {
                                                                    Shipping.Paragraphs.map((Singlepara, index) => (
                                                                        <p className='text mb-2 mb-md-4' key={index}>{Singlepara}</p>
                                                                    ))
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }
                                        else {
                                            return (
                                                <>
                                                    <div className="col-md-6 mt-3 mt-md-5 px-md-4 order-1 order-lg-0">
                                                        <div className="shipping-text h-100 d-flex flex-column justify-content-center">
                                                            <h3 className="md-heading secondary-text"><span className="md-heading pe-2">{index+1}.</span>{Shipping.ShippingName}</h3>
                                                            <div className="the-text mt-2 mt-md-4">
                                                                {
                                                                    Shipping.Paragraphs.map((Singlepara, index) => (
                                                                        <p className='text mb-2 mb-md-4' key={index}>{Singlepara}</p>
                                                                    ))
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-5 px-md-4 order-0 order-lg-1">
                                                        <figure className="shipping-image">
                                                            <img src={Shipping.Image} alt="" className="the-img w-100 img-fluid" />
                                                        </figure>
                                                    </div>
                                                </>
                                            )
                                        }
                                    })
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Terms Conditions Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default ShipperInsurance;